"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _utils = require("@trs/utils");
var _TablePagination = _interopRequireDefault(require("./TablePagination.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ICON_SIZE = 18;
var ITEMS_LIMIT = 100000;
var TablePagination = function TablePagination(_ref) {
  var currentPage = _ref.currentPage,
    totalResults = _ref.totalResults,
    resultsPerPage = _ref.resultsPerPage,
    onPageChange = _ref.onPageChange,
    isTableLoading = _ref.isTableLoading,
    disableLastPageArrow = _ref.disableLastPageArrow,
    otherProps = _ref.otherProps,
    tableFooterTracking = _ref.tableFooterTracking,
    withFormattedData = _ref.withFormattedData;
  return /*#__PURE__*/_react["default"].createElement(_TablePagination["default"], _extends({
    currentPage: currentPage,
    totalResults: totalResults,
    resultsPerPage: resultsPerPage,
    isTableLoading: isTableLoading,
    itemsLimit: ITEMS_LIMIT,
    disableLastPageArrow: disableLastPageArrow
  }, otherProps), /*#__PURE__*/_react["default"].createElement("span", {
    id: "tablePaginationFirst",
    className: "pagination-first",
    onClick: function onClick() {
      !isTableLoading && currentPage > 1 && onPageChange(1);
      if (!isTableLoading && currentPage > 1) tableFooterTracking.tablePaginationFirst();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-ios-arrow-back",
    size: ICON_SIZE
  }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-ios-arrow-back",
    size: ICON_SIZE
  })), /*#__PURE__*/_react["default"].createElement("span", {
    id: "tablePaginationPrevious",
    className: "pagination-previous",
    onClick: function onClick() {
      !isTableLoading && currentPage > 1 && onPageChange(currentPage - 1);
      if (!isTableLoading && currentPage > 1) tableFooterTracking.tablePaginationPrev();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-ios-arrow-back",
    size: ICON_SIZE
  })), /*#__PURE__*/_react["default"].createElement("span", {
    id: "tablePaginationStatus",
    className: "pagination-status"
  }, withFormattedData ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _utils.formatNumber)((currentPage - 1) * resultsPerPage + 1), " -", ' ', resultsPerPage <= totalResults && currentPage * resultsPerPage < totalResults ? (0, _utils.formatNumber)(currentPage * resultsPerPage) : (0, _utils.formatNumber)(totalResults), ' ', "/ ", (0, _utils.formatNumber)(totalResults)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (currentPage - 1) * resultsPerPage + 1, " -", ' ', resultsPerPage <= totalResults && currentPage * resultsPerPage < totalResults ? currentPage * resultsPerPage : totalResults, ' ', "/ ", totalResults)), /*#__PURE__*/_react["default"].createElement("span", {
    id: "tablePaginationNext",
    className: "pagination-next",
    onClick: function onClick() {
      !isTableLoading && Math.ceil(totalResults / resultsPerPage) > currentPage && onPageChange(currentPage + 1);
      if (!isTableLoading && Math.ceil(totalResults / resultsPerPage) > currentPage) tableFooterTracking.tablePaginationNext();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-ios-arrow-forward",
    size: ICON_SIZE
  })), /*#__PURE__*/_react["default"].createElement("span", {
    id: "tablePaginationLast",
    className: "pagination-last",
    onClick: function onClick() {
      if (isTableLoading) return;
      var hasNextPage = Math.ceil(totalResults / resultsPerPage) > currentPage;
      if (disableLastPageArrow && hasNextPage && totalResults < ITEMS_LIMIT || !disableLastPageArrow && hasNextPage) {
        tableFooterTracking.tablePaginationLast();
        onPageChange(totalResults % resultsPerPage === 0 ? totalResults / resultsPerPage : Math.floor(totalResults / resultsPerPage) + 1);
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-ios-arrow-forward",
    size: ICON_SIZE
  }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-ios-arrow-forward",
    size: ICON_SIZE
  })));
};
TablePagination.defaultProps = {
  isTableLoading: false,
  tableFooterTracking: {
    tablePaginationFirst: function tablePaginationFirst() {},
    tablePaginationPrev: function tablePaginationPrev() {},
    tablePaginationNext: function tablePaginationNext() {},
    tablePaginationLast: function tablePaginationLast() {}
  }
};
TablePagination.propTypes = {
  tableFooterTracking: _propTypes["default"].shape({
    tablePaginationFirst: _propTypes["default"].func,
    tablePaginationPrev: _propTypes["default"].func,
    tablePaginationNext: _propTypes["default"].func,
    tablePaginationLast: _propTypes["default"].func
  }),
  currentPage: _propTypes["default"].number.isRequired,
  totalResults: _propTypes["default"].number.isRequired,
  resultsPerPage: _propTypes["default"].number.isRequired,
  onPageChange: _propTypes["default"].func.isRequired,
  isTableLoading: _propTypes["default"].bool,
  disableLastPageArrow: _propTypes["default"].bool.isRequired
};
TablePagination.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TablePagination",
  "props": {
    "isTableLoading": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "tableFooterTracking": {
      "defaultValue": {
        "value": "{\r\n  tablePaginationFirst: () => {},\r\n  tablePaginationPrev: () => {},\r\n  tablePaginationNext: () => {},\r\n  tablePaginationLast: () => {},\r\n}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "tablePaginationFirst": {
            "name": "func",
            "required": false
          },
          "tablePaginationPrev": {
            "name": "func",
            "required": false
          },
          "tablePaginationNext": {
            "name": "func",
            "required": false
          },
          "tablePaginationLast": {
            "name": "func",
            "required": false
          }
        }
      },
      "required": false
    },
    "currentPage": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "totalResults": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "resultsPerPage": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "onPageChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "disableLastPageArrow": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": true
    }
  }
};
var _default = TablePagination;
exports["default"] = _default;